import { useCallback, useEffect, useMemo, useState } from 'react';
import { Box, Grid, LinearProgress, useMediaQuery, useTheme } from '@mui/material';
import { useNavigate } from 'react-router-dom';

import { LayoutBase } from '../../layouts';
import { ToolsDashbord } from '../../components/custom';
import { CustomAlert, VCard } from '../../components/shared';
import { DamsServices, IDamsList } from '../../services/api/dams/DamServices';
import { useAuthContext } from '../../context';
import { Cell, Legend, Pie, PieChart, ResponsiveContainer, Tooltip } from 'recharts';

export const Dashboard = () => {

  const theme = useTheme();
  const smDown = useMediaQuery(theme.breakpoints.down('sm'));

  const [rows, setRows] = useState<IDamsList[]>([]);
  const navigate = useNavigate();
  const { userData } = useAuthContext();
  const [isLoadin, setIsLoadin] = useState(true);
  const [alertInfo, setAlertInfo] = useState<{ open: boolean; message: string; severity: 'success' | 'error' | 'warning' | 'info' }>({
    open: false,
    message: '',
    severity: 'success'
  });

  // const pagePermissionsString: string | undefined = useMemo(() => {
  //   return userData?.nivel_acesso?.acompanhamentos?.visualizacao;
  // }, [userData]);

  // const hasActionPermission = useCallback((action: 'add' | 'edit' | 'remove' | 'view' ): boolean => {
  //   if (typeof pagePermissionsString === 'string' && pagePermissionsString !== '') {
  //     const actions = pagePermissionsString.split(',').map(s => s.trim());
  //     return actions.includes(action);
  //   }
  //   return false;
  // }, [pagePermissionsString]);

  const pagePermissionsStringDash: string | undefined = useMemo(() => {
    return userData?.nivel_acesso?.dashboard?.dashboardGeral;
  }, [userData]);

  const hasDashPermission = useCallback((action: 'add' | 'edit' | 'remove' | 'view'): boolean => {
    if (typeof pagePermissionsStringDash === 'string' && pagePermissionsStringDash !== '') {
      const actions = pagePermissionsStringDash.split(',').map(s => s.trim());
      return actions.includes(action);
    }
    return false;
  }, [pagePermissionsStringDash]);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = () => {
    setIsLoadin(true);
    if (userData.id_empresa) {
      DamsServices.get(userData.id_empresa)
        .then((response) => {
          if (response instanceof Error) {
            setAlertInfo({ open: true, message: `Erro ao buscar dados! error: ${response.message}`, severity: 'error' });
          } else {
            if (response.length > 0) {
              if (userData.barragens_visiveis && userData.barragens_visiveis !== '' && typeof userData.barragens_visiveis === 'string') {
                const listaUuids = userData.barragens_visiveis.split(',');
                const filter = response.filter(i => listaUuids.includes(i.uuid));
                setRows(filter);
                setIsLoadin(false);
              } else {
                const dams = response.filter(index => index.status === true);
                setRows(dams);
                setIsLoadin(false);
              }
            } else {
              setIsLoadin(false);
              setAlertInfo({ open: true, message: 'Não há nenhuma barragem cadastrada', severity: 'info' });
            }
          }
        });
    } else {
      setAlertInfo({ open: true, message: 'Sem empresa vinculada a você', severity: 'error' });
    }
  };

  // Conta quantos de cada valor
  const contagem = rows.reduce<Record<string, number>>((acc, curr) => {
    const key = curr.npgb || 'Sem dado';
    acc[key] = (acc[key] || 0) + 1;
    return acc;
  }, {});

  // Transforma em array para o gráfico
  const pieData = Object.entries(contagem).map(([name, value]) => ({
    name,
    value,
  }));

  const cores: Record<string, string> = {
    Normal: '#4caf50',
    Alto: '#ff9800',
    Crítico: '#f44336',
    'Sem dado': '#9e9e9e',
  };

  // console.log(rows);
  return (
    <LayoutBase
      title='Dashboard'
      tollBar={(
        <ToolsDashbord />
      )}
    >
      {isLoadin ? (
        <LinearProgress />
      ) : (
        <Box margin={0} display={'flex'} flexDirection={'column'}>
          <Grid container direction={'column'} padding={2} spacing={2}>
            <Grid container direction={'row'} spacing={4} padding={1}>
              {rows.filter(dam => dam.status === true).map((dam, index) => (
                <Grid key={index} item xs={smDown ? 12 : 4}>
                  <VCard
                    title={dam.nome}
                    altText={dam.nome}
                    imageUrl={dam.imagem}
                    subtitle={dam.update_date}
                    button1Label='Informações da barragem'
                    onButton1Click={() => navigate(`/information_dam/${dam.uuid}`)}
                    button2Label='Dashboard de informação'
                    onButton2Click={() => navigate(`/information_dam/${dam.uuid}/kpi`)}
                    company={false}
                    npgbText={dam.npgb}
                    // hasViewPermission={hasActionPermission('view')}
                    hasDashPermission={hasDashPermission('view')}
                  />
                </Grid>
              ))}
            </Grid>
          </Grid>
          {alertInfo.open &&
            <CustomAlert
              message={alertInfo.message}
              severity={alertInfo.severity}
            />
          }
        </Box>
      )}
    </LayoutBase>
  );
};